<template>
  <div>
    <v-snackbar v-model="snackbar" color="success" top>
      {{ "alerts_business_updated" | localize }}
    </v-snackbar>
    <VRow
      class="mt-12 mx-1"
      v-if="!editBusiness && $vuetify.breakpoint.smAndDown"
    >
      <v-progress-linear
        height="17"
        style="border-radius: 20px"
        color="#73AFE7"
        value="40"
      ></v-progress-linear>
    </VRow>
    <v-card-title v-if="!editBusiness && !socials">
      <VRow
        no-gutters
        style="word-break: normal"
        :class="
          $vuetify.breakpoint.smAndDown ? 'font-weight-bold mt-2' : 'mt-8'
        "
        justify="center"
        justify-sm="start"
      >
        {{ "add_business_third_step_subtitle" | localize }}
      </VRow>
    </v-card-title>
    <v-card-title
      v-if="socials"
      class="justify-center px-1"
      :style="$vuetify.breakpoint.xs ? 'width : 190px' : ''"
    >
      Select the days and hours you are open to the public:
    </v-card-title>
    <v-card-text class="mt-3 openHours">
      <VRow no-gutters v-for="(day, key) in days" :key="key" class="mb-4">
        <v-col class="col-12 col-sm-4">
          <v-checkbox
            v-if="!$vuetify.breakpoint.smAndDown"
            dense
            color="#72AFE7"
            style="width: 120px"
            class="checkDay my-auto mx-auto to-label"
            :label="day.day"
            v-model="day.checked"
            hide-details
            :disabled="
              loggedUser.role_id === '0' ||
              loggedUser.role_id === '1' ||
              loggedUser.role_id === '4'
                ? false
                : true
            "
          ></v-checkbox>
          <div v-else class="text-center">
            <div style="font-size: 22px; line-height: 22px">
              {{ day.day }}
            </div>
            <v-switch
              v-model="day.checked"
              inset
              style="width: 40px"
              class="mx-auto checkDay"
              hide-details
              :disabled="
                loggedUser.role_id === '0' ||
                loggedUser.role_id === '1' ||
                loggedUser.role_id === '4'
                  ? false
                  : true
              "
              color="#72AFE7"
            ></v-switch>
            <span
              v-if="day.checked"
              style="font-size: 9.42857px; line-height: 11px"
              >{{ "mobile_add_business_hours_opened" | localize }}</span
            >
            <span
              v-if="!day.checked"
              style="font-size: 9.42857px; line-height: 11px"
              >{{ "mobile_add_business_hours_closed" | localize }}</span
            >
          </div>
        </v-col>
        <v-col class="col-6 col-sm-4">
          <div
            class="mx-md-15 mb-5"
            :class="{ 'd-flex align-center': $vuetify.breakpoint.smAndDown }"
          >
            <h4
              v-if="
                ($vuetify.breakpoint.smAndDown &&
                  day.checked &&
                  loggedUser.role_id === '1') ||
                (day.checked && loggedUser.role_id === '0') ||
                (day.checked && loggedUser.role_id === '4') ||
                !$vuetify.breakpoint.smAndDown
              "
              :class="{ 'mr-2': $vuetify.breakpoint.smAndDown }"
            >
              {{ "add_business_third_step_from" | localize }}
            </h4>
            <v-select
              v-if="
                ($vuetify.breakpoint.smAndDown &&
                  day.checked &&
                  loggedUser.role_id === '1') ||
                (day.checked && loggedUser.role_id === '0') ||
                (day.checked && loggedUser.role_id === '4') ||
                !$vuetify.breakpoint.smAndDown
              "
              :disabled="
                (day.checked && loggedUser.role_id === '1') ||
                (day.checked && loggedUser.role_id === '0') ||
                (day.checked && loggedUser.role_id === '4')
                  ? false
                  : true
              "
              color="rgb(218, 218, 218)"
              item-color="#72AFE7"
              style="width: 120px"
              v-model="day.from"
              class="from"
              dense
              hide-details
              outlined
              :menu-props="{ bottom: true, offsetY: true }"
              :items="Object.values(hours)"
            ></v-select>
          </div>
        </v-col>
        <v-col class="col-6 col-sm-4 ml-auto text-right text-sm-left">
          <div
            class="mx-md-15 mx-lg-0"
            :class="{
              ' d-flex align-center ml-4': $vuetify.breakpoint.smAndDown,
            }"
          >
            <h4
              v-if="
                ($vuetify.breakpoint.smAndDown &&
                  day.checked &&
                  loggedUser.role_id === '1') ||
                (day.checked && loggedUser.role_id === '0') ||
                (day.checked && loggedUser.role_id === '4') ||
                !$vuetify.breakpoint.smAndDown
              "
              :class="{ 'mr-2': $vuetify.breakpoint.smAndDown }"
            >
              {{ "add_business_third_step_to" | localize }}
            </h4>
            <v-select
              v-if="
                ($vuetify.breakpoint.smAndDown &&
                  day.checked &&
                  loggedUser.role_id === '1') ||
                (day.checked && loggedUser.role_id === '0') ||
                (day.checked && loggedUser.role_id === '4') ||
                !$vuetify.breakpoint.smAndDown
              "
              :disabled="
                (day.checked && loggedUser.role_id === '1') ||
                (day.checked && loggedUser.role_id === '0') ||
                (day.checked && loggedUser.role_id === '4')
                  ? false
                  : true
              "
              color="rgb(218, 218, 218)"
              item-color="#72AFE7"
              style="width: 120px"
              v-model="day.to"
              class="to ml-auto ml-sm-0"
              dense
              outlined
              hide-details
              :menu-props="{ bottom: true, offsetY: true }"
              :items="Object.values(hours)"
            ></v-select>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.smAndDown" class="col-12">
          <v-divider style="border: 2px solid #5e5e5e42" />
        </v-col>
      </VRow>
    </v-card-text>
    <v-card-actions>
      <VRow
        align="center"
        justify="center"
        class="mx-auto"
        v-if="$vuetify.breakpoint.smAndDown && !editBusiness"
      >
        <v-col>
          <v-btn
            block
            class="white--text nextOpen"
            color="#72AFE7"
            v-on:click="next()"
            style="
              text-transform: none;
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            "
            v-if="!editBusiness && !socials"
            >{{ "add_business_next" | localize }}</v-btn
          >
          <v-btn
            block
            text
            class="mt-3"
            color="#72AFE7"
            v-on:click="$emit('previous')"
            v-if="!editBusiness"
            style="text-transform: none"
            >{{ "add_business_prev" | localize }}</v-btn
          >
        </v-col>
      </VRow>
      <div
        class="ml-auto"
        v-if="!$vuetify.breakpoint.smAndDown && !editBusiness"
      >
        <v-btn block outlined color="#72AFE7" v-on:click="$emit('previous')">{{
          "add_business_prev" | localize
        }}</v-btn>
      </div>
      <div
        class="ml-2 d-flex nextOpen"
        v-if="!$vuetify.breakpoint.smAndDown && !editBusiness"
      >
        <v-btn class="white--text" color="#72AFE7" v-on:click="next()">{{
          "add_business_next" | localize
        }}</v-btn>
      </div>
      <div
        class="ml-auto d-flex"
        v-if="
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            !socials &&
            loggedUser.role_id === '0') ||
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            loggedUser.role_id === '1')
        "
      >
        <v-btn :loading="updateLoading" class="white--text" color="#72AFE7" v-on:click="update()">{{
          "add_business_update" | localize
        }}</v-btn>
      </div>
      <div
        class="ml-auto d-flex"
        v-if="
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            socials &&
            loggedUser.role_id === '0') ||
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            loggedUser.role_id === '1')
        "
      >
        <v-btn
          class="white--text"
          color="#72AFE7"
          v-on:click="updateSocial()"
          >{{ "add_business_update" | localize }}</v-btn
        >
      </div>
    </v-card-actions>
  </div>
</template>

<script>
import BusinessService from "@/requests/Business/BusinessService";
import SocialService from "@/requests/Socials/SocialService";
import requestFormData from "@/requests/requestFormData";
import { mapGetters } from "vuex";
import Shepherd from "shepherd.js";
import en from "@/locales/en.json";
import es from "@/locales/es.json";
const allowTouchmove = (event) => {
  event.stopPropagation();
};

const tour = new Shepherd.Tour({
  useModalOverlay: true,
  defaultStepOptions: {
    cancelIcon: {
      enabled: true,
    },
    scrollTo: { block: "center" },
    when: {
      show() {
        const target = this.getTarget();
        if (target) {
          target.addEventListener("touchmove", allowTouchmove);
        }
      },
      hide() {
        const target = this.getTarget();
        if (target) {
          target.removeEventListener("touchmove", allowTouchmove);
        }
      },
    },
  },
  popperOptions: {
    modifiers: [{ name: "offset", options: { offset: [0, 100] } }],
  },
});

tour.on("cancel", () => {
  localStorage.tutorialStep = tour.getCurrentStep().id;
});

export default {
  props: {
    editBusiness: {
      type: Object,
      require: false,
    },
    updates: {
      require: false,
    },
  },
  data: () => ({
    snackbar: false,
    socials: false,
    lang: null,
    updateLoading: false,
    hours: [
      "00:00",
      "00:30",
      "01:00",
      "01:30",
      "02:00",
      "02:30",
      "03:00",
      "03:30",
      "04:00",
      "04:30",
      "05:00",
      "05:30",
      "06:00",
      "06:30",
      "07:00",
      "07:30",
      "08:00",
      "08:30",
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:30",
      "21:00",
      "21:30",
      "22:00",
      "22:30",
      "23:00",
      "23:30",
    ],
    days: [
      {
        name: "Mon",
        day: "Monday",
        from: "09:00",
        to: "19:00",
        checked: true,
      },
      {
        name: "Tue",
        day: "Tuesday",
        from: "09:00",
        to: "19:00",
        checked: true,
      },
      {
        name: "Wed",
        day: "Wednesday",
        from: "09:00",
        to: "19:00",
        checked: true,
      },
      {
        name: "Thu",
        day: "Thursday",
        from: "09:00",
        to: "19:00",
        checked: true,
      },
      {
        name: "Fri",
        day: "Friday",
        from: "09:00",
        to: "19:00",
        checked: true,
      },
      {
        name: "Sat",
        day: "Saturday",
        from: "09:00",
        to: "14:00",
        checked: true,
      },
      {
        name: "Sun",
        day: "Sunday",
        from: "09:00",
        to: "19:00",
        checked: false,
      },
    ],
  }),
  destroyed() {
    this.resetSteps();
  },
  mounted() {
    if (process.env.VUE_APP_TYPE == "Social") {
      this.socials = true;
      this.days[5].checked = false;
      for (let i = 0; i < 5; i++) {
        this.days[i].from = "10:00";
        this.days[i].to = "17:00";
      }
    }
    this.updateStepsText();
    console.log(this.editBusiness);
    if (this.editBusiness) {
      console.log(this.editBusiness);
      this.getEditHours();
    }
  },
  watch: {
    updates: {
      deep: true,
      handler() {
        if (this.socials) {
          this.updateSocial();
        } else {
          this.update();
        }
      },
    },
    days: {
      deep: true,
      handler() {
        if (this.editBusiness && this.$vuetify.breakpoint.smAndDown) {
          let business = {};

          let working_days = {};
          let working_hours = {};
          for (let i = 0; i < this.days.length; i++) {
            if (this.days[i].checked) {
              working_days[`${this.days[i].name}`] = "on";
              working_hours[`${this.days[i].name}`] = {
                from: this.days[i].from,
                to: this.days[i].to,
              };
            }
          }
          business.shop_working_days = working_days;
          business.working_hours = working_hours;

          this.$emit("changed_business", business);
        }
      },
    },
    loggedUser: function (newUser) {
      this.loggedUser = newUser;
      this.updateStepsText();
    },
  },
  methods: {
    updateStepsText() {
      if (this.loggedUser.locale === "en") {
        this.lang = en;
      } else {
        this.lang = es;
      }
      this.days[0].day = this.lang["add_business_third_step_monday"];
      this.days[1].day = this.lang["add_business_third_step_tuesday"];
      this.days[2].day = this.lang["add_business_third_step_wednesday"];
      this.days[3].day = this.lang["add_business_third_step_thursday"];
      this.days[4].day = this.lang["add_business_third_step_friday"];
      this.days[5].day = this.lang["add_business_third_step_saturday"];
      this.days[6].day = this.lang["add_business_third_step_sunday"];
      this.resetSteps();
    },
    resetSteps() {
      tour.complete();
      tour.removeStep("openHours");
      tour.removeStep("checkDay");
      tour.removeStep("from");
      tour.removeStep("to");
      tour.removeStep("openHours2");
      tour.removeStep("nextOpen");
    },
    next() {
      let check = tour.isActive();
      let working_days = {};
      let working_hours = {};
      for (let i = 0; i < this.days.length; i++) {
        if (this.days[i].checked) {
          working_days[`${this.days[i].name}`] = "on";
          working_hours[`${this.days[i].name}`] = {
            from: this.days[i].from,
            to: this.days[i].to,
          };
        }
      }
      this.$emit("addedOpenHours", working_days, working_hours, check);
      tour.complete();
    },
    getEditHours() {
      let working_days = null;
      if (this.socials) {
        working_days = this.editBusiness.working_days;
      } else {
        working_days = this.editBusiness.shop_working_days;
      }
      let working_hours = this.editBusiness.working_hours;
      console.log(working_days, working_hours);
      for (let i = 0; i < this.days.length; i++) {
        {
          if (working_days[`${this.days[i].name}`] === "on") {
            this.days[i].checked = true;
            this.days[i].from = working_hours[`${this.days[i].name}`].from;
            this.days[i].to = working_hours[`${this.days[i].name}`].to;
          } else {
            this.days[i].checked = false;
          }
        }
      }
    },
    update() {
      this.updateLoading = true
      let working_days = {};
      let working_hours = {};
      for (let i = 0; i < this.days.length; i++) {
        if (this.days[i].checked) {
          working_days[`${this.days[i].name}`] = "on";
          working_hours[`${this.days[i].name}`] = {
            from: this.days[i].from,
            to: this.days[i].to,
          };
        }
      }
      let subcategories = [];
      if (this.editBusiness.categories.length >= 1) {
        for (
          let i = 0;
          i < this.editBusiness.categories[1].subcategory.length;
          i++
        ) {
          subcategories.push({
            category_id: parseInt(this.editBusiness.categories[1].id),
            subcategory_id: this.editBusiness.categories[1].subcategory[i].id,
          });
        }
      } else {
        [{ ...this.editBusiness.categories }].forEach((category) =>
          subcategories.push({ category_id: Object.keys(category)[0] })
        );
      }
      let data = {
        //type: parseInt(this.editBusiness.type_id),
        shop_name: this.editBusiness.shop_name,
        shop_description: this.editBusiness.shop_description,
        shop_email: this.editBusiness.shop_email,
        shop_logo: this.editBusiness.shop_logo,
        phone_code: this.editBusiness.phone_code,
        phone_number: this.editBusiness.phone_number,
        shop_website: this.editBusiness.shop_website,
        address: this.editBusiness.address,
        geo_lat: this.editBusiness.geo_lat,
        geo_lon: this.editBusiness.geo_lon,
        neighbourhood: parseInt(this.editBusiness.neighbourhood),
        device_access: parseInt(this.editBusiness.device_access),
        internet: this.editBusiness.internet,
        size: parseInt(this.editBusiness.size),
        canaco_id: this.editBusiness.canaco_id,
        discount_amount_min:
          parseInt(this.editBusiness.discount_amount_min) || 5,
        discount_amount_max:
          parseInt(this.editBusiness.discount_amount_max) || 5,
        discount_type: this.editBusiness.discount_type || "All",
        working_days: working_days,
        working_hours: working_hours,
        category: subcategories,
        city_id: this.editBusiness.city_id,
        municipality: this.editBusiness.municipality,
      };
      let form = requestFormData.jsonToFormData(data);
      BusinessService.updateBusiness(this.$route.params.bid, form).then(() => {
        this.snackbar = true;
        this.updateLoading = false
        this.$emit("updated");
      });
    },
    updateSocial() {
      let working_days = {};
      let working_hours = {};
      for (let i = 0; i < this.days.length; i++) {
        if (this.days[i].checked) {
          working_days[`${this.days[i].name}`] = "on";
          working_hours[`${this.days[i].name}`] = {
            from: this.days[i].from,
            to: this.days[i].to,
          };
        }
      }
      let data = {
        type: parseInt(this.editBusiness.type),
        name: this.editBusiness.name,
        description: this.editBusiness.description,
        email: this.editBusiness.email,
        phone_code: this.editBusiness.phone_code,
        phone_number: this.editBusiness.phone_number,
        website: this.editBusiness.website,
        address: this.editBusiness.address,
        geo_lat: this.editBusiness.geo_lat,
        geo_lon: this.editBusiness.geo_lon,
        neighbourhood: parseInt(this.editBusiness.neighbourhood),
        internet: this.editBusiness.internet,
        size: parseInt(this.editBusiness.size),
        is_public: this.editBusiness.is_public,
        working_days: working_days,
        working_hours: working_hours,
      };
      let form = requestFormData.jsonToFormData(data);
      SocialService.updateSocial(this.$route.params.sid, form).then(() => {
        this.snackbar = true;
        this.$emit("updated");
      });
    },
    getLast() {
      setTimeout(function () {
        tour.start();
        tour.show("nextOpen");
      }, 700);
    },
    nextTutorial() {
      let that = this;
      if (!tour.getById("openHours")) {
        tour.addStep({
          id: "openHours",
          text: that.lang["tour-create-business-enter-schedule"],
          attachTo: {
            element: ".openHours",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action() {
                tour.complete();
                that.$emit("toLastStep");
              },
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("checkDay")) {
        tour.addStep({
          id: "checkDay",
          text: that.lang["tour-create-business-day"],
          attachTo: {
            element: ".checkDay",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("from")) {
        tour.addStep({
          id: "from",
          text: that.lang["tour-create-business-from"],
          attachTo: {
            element: ".from",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("to")) {
        tour.addStep({
          id: "to",
          text: that.lang["tour-create-business-to"],
          attachTo: {
            element: ".to",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("openHours2")) {
        tour.addStep({
          id: "openHours2",
          text: that.lang["tour-create-business-enter-schedule"],
          attachTo: {
            element: ".openHours",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("nextOpen")) {
        tour.addStep({
          id: "nextOpen",
          text: that.lang["tour-create-business-next"],
          attachTo: {
            element: ".nextOpen",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      tour.start();
      console.log(tour.isActive());
      if (tour.isActive()) {
        let tutorialStep = localStorage.tutorialStep;
        if (
          tutorialStep == "openHours" ||
          tutorialStep == "openHours2" ||
          tutorialStep == "checkDay" ||
          tutorialStep == "from" ||
          tutorialStep == "to" ||
          tutorialStep == "nextOpen"
        ) {
          tour.hide();
          tour.show(localStorage.tutorialStep);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["loggedUser"]),
  },
};
</script>

<style scoped>
.to-label {
  font-size: 16px;
  min-height: 8px;
  font-weight: 600;
}
</style>